import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { Config } from '../shared/services/config.service';
import { AppModule } from './app.module';
import { enableProdMode } from '@angular/core';

const config = new Config();
if (config.getConfig('mode') === 'production') {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/app/main.ts